export default __webpack_public_path__ + "static/media/google.66bb7093.png";